import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import JobListing from './pages/JobListing';
import JobDetail from './pages/JobDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import HowItWorks from './pages/HowItWorks';
import AuthCallback from './pages/AuthCallback';
import { Toaster } from './components/ui/sonner';
import ErrorBoundary from './components/ErrorBoundary';

const PAINEL_URL = import.meta.env.VITE_PAINEL_URL || 'https://vagasbrusque.com.br';

/** Redireciona para o painel externo (Livewire) */
function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
}

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
}

export default function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ErrorBoundary>
        <ScrollToTop />
        <Routes>
        {/* Páginas públicas (front) */}
        <Route path="/" element={<Home />} />
        <Route path="/vagas" element={<JobListing />} />
        <Route path="/vaga/:id" element={<JobDetail />} />

        {/* Páginas Institucionais */}
        <Route path="/sobre" element={<About />} />
        <Route path="/contato" element={<Contact />} />
        <Route path="/planos" element={<HowItWorks />} />
        <Route path="/como-funciona" element={<HowItWorks />} />
        <Route path="/termos" element={<Terms />} />
        <Route path="/privacidade" element={<Privacy />} />

        {/* Auth callback (sincroniza token do painel Livewire → localStorage) */}
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Auth → redireciona para painel Livewire (domínio diferente) */}
        <Route path="/login" element={<ExternalRedirect to={`${PAINEL_URL}/login`} />} />
        <Route path="/cadastro" element={<ExternalRedirect to={`${PAINEL_URL}/cadastro`} />} />
        <Route path="/cadastro/empresa" element={<ExternalRedirect to={`${PAINEL_URL}/cadastro/empresa`} />} />
        <Route path="/cadastro/candidato" element={<ExternalRedirect to={`${PAINEL_URL}/cadastro/candidato`} />} />
        <Route path="/forgot-password" element={<ExternalRedirect to={`${PAINEL_URL}/forgot-password`} />} />
        <Route path="/recuperar-senha" element={<ExternalRedirect to={`${PAINEL_URL}/forgot-password`} />} />
        <Route path="/reset-password" element={<ExternalRedirect to={`${PAINEL_URL}/reset-password`} />} />
        <Route path="/verify-email" element={<ExternalRedirect to={`${PAINEL_URL}/verify-email`} />} />
        <Route path="/email/verify" element={<ExternalRedirect to={`${PAINEL_URL}/email/verify`} />} />
        <Route path="/email/verify/:id/:hash" element={<ExternalRedirect to={`${PAINEL_URL}/email/verify`} />} />
        <Route path="/email-verified" element={<ExternalRedirect to={`${PAINEL_URL}/login`} />} />

        {/* Dashboards → redireciona para painel Livewire (domínio diferente) */}
        <Route path="/empresa/*" element={<ExternalRedirect to={`${PAINEL_URL}/empresa/dashboard`} />} />
        <Route path="/candidato/*" element={<ExternalRedirect to={`${PAINEL_URL}/candidato/dashboard`} />} />
        <Route path="/admin/*" element={<ExternalRedirect to={`${PAINEL_URL}/admin/dashboard`} />} />
        </Routes>
        <Toaster />
      </ErrorBoundary>
    </Router>
  );
}
